import { render } from "./CreateSizeModal.vue?vue&type=template&id=2b38a99b&scoped=true&ts=true"
import script from "./CreateSizeModal.vue?vue&type=script&lang=ts"
export * from "./CreateSizeModal.vue?vue&type=script&lang=ts"

import "./CreateSizeModal.vue?vue&type=style&index=0&id=2b38a99b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b38a99b"]])

export default __exports__